export default {
  NODE_ENV: "development",
  API_URL: "http://127.0.0.1:3000",
  TG_BOT_URL: "https://t.me/ShonovBot"
};
